import Vue from 'vue'

import VueRouter from 'vue-router'
Vue.use(VueRouter)

import StepsFlux from '../views/StepsFlux';
import Page404 from "../views/_commons/fr/Page404";


let routes = [
    {
        path: `/:step?`,
        component: StepsFlux,
        name: 'form',
    },
    {path: `/*`, component: Page404, name: '404'}
];

export default new VueRouter({
    mode: 'history',
    base:window.slug,
    routes
})
